/**
 * Practice-size enum and labels.
 *
 * Lives in $lib (not $server) because the apply form uses it on the
 * client too. Pure constants — no runtime side effects, no PII.
 */

export const PRACTICE_SIZES = ['solo', '2_4', '5_10', '11_25', '26_49', '50_plus'] as const;
export type PracticeSize = (typeof PRACTICE_SIZES)[number];

export function practiceSizeLabel(size: PracticeSize): string {
	switch (size) {
		case 'solo':
			return 'Solo';
		case '2_4':
			return '2–4 MDs';
		case '5_10':
			return '5–10 MDs';
		case '11_25':
			return '11–25 MDs';
		case '26_49':
			return '26–49 MDs';
		case '50_plus':
			return '50+ MDs';
	}
}

export function isPracticeSize(v: string): v is PracticeSize {
	return (PRACTICE_SIZES as readonly string[]).includes(v);
}
